export default "__VITE_ASSET__Drqe0Df2__"